<div class="dialog-header" mat-dialog-title>
    <div class="header-title">
        <mat-icon class="warning-icon">warning</mat-icon>
        <span>Dubbele planningen gevonden</span>
    </div>
    <button class="close-button" (click)="onCancel()" mat-icon-button>
        <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
    </button>
</div>

<div class="dialog-content" mat-dialog-content>
    <p class="warning-text">
        Er zijn <strong>{{ data.entries.length }}</strong> planningen gevonden voor
        <strong>{{ data.projectName }}</strong> op <strong>{{ formattedDate }}</strong
        >. Selecteer een planning om een actie uit te voeren.
    </p>

    <div class="entries-list">
        @for (entry of data.entries; track $index) {
            <mat-card
                class="entry-card"
                [class.selected]="isSelected(entry)"
                [class.asphalt-entry]="entry | isAsphaltEntry"
                (click)="selectEntry(entry)">
                <mat-card-content class="entry-content">
                    <div class="entry-header">
                        <div class="entry-activity">
                            <mat-icon class="activity-icon">{{ getActivityIcon(entry) }}</mat-icon>
                            <span class="activity-label">{{ getActivityLabel(entry) }}</span>
                        </div>
                        <div class="entry-time">
                            <mat-icon class="time-icon">schedule</mat-icon>
                            <span>{{ getTimeLabel(entry) }}</span>
                        </div>
                    </div>
                    @if (entry | isAsphaltEntry) {
                        <div class="entry-badge">
                            <mat-icon class="badge-icon">info</mat-icon>
                            <span class="badge-text">Ingepland via asfaltplanning</span>
                        </div>
                    }
                </mat-card-content>
            </mat-card>
        }
    </div>

    @if (selectedEntry) {
        <div class="action-section">
            @if (!(selectedEntry | isAsphaltEntry)) {
                <h4 class="action-title">Acties voor geselecteerde planning</h4>

                <mat-form-field class="date-picker-field" appearance="outline">
                    <mat-label>Verplaatsen naar datum</mat-label>
                    <input
                        [formControl]="dateControl"
                        [matDatepicker]="picker"
                        (focus)="picker.open()"
                        matInput
                        readonly />
                    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            } @else {
                <div class="info-message">
                    <mat-icon class="info-icon">info</mat-icon>
                    <p>
                        Deze asfalt planning kan niet worden verwijderd of verplaatst vanuit dit scherm. Wijzig de
                        planning in het hoofdscherm.
                    </p>
                </div>
            }
        </div>
    }
</div>

<div class="action-buttons" mat-dialog-actions>
    <button class="cancel-button" (click)="onCancel()" mat-button>Sluiten</button>

    @if (selectedEntry && !(selectedEntry | isAsphaltEntry)) {
        <div class="action-group">
            <button (click)="onDeleteEntry()" mat-raised-button color="warn">
                <mat-icon>delete</mat-icon>
                Verwijderen
            </button>
            <button [disabled]="!dateControl.value" (click)="onMoveDate()" mat-raised-button color="primary">
                <mat-icon>event</mat-icon>
                Datum opslaan
            </button>
        </div>
    }
</div>
